var map = {
	"./imagen.jpg": 1872,
	"./imagen1.jpg": 6567,
	"./imagen10.jpg": 519,
	"./imagen11.jpg": 4714,
	"./imagen12.jpg": 1234,
	"./imagen13.jpg": 4024,
	"./imagen2.jpg": 9112,
	"./imagen3.jpg": 6981,
	"./imagen4.jpg": 4510,
	"./imagen5.jpg": 2555,
	"./imagen6.jpg": 572,
	"./imagen7.jpg": 1625,
	"./imagen8.jpg": 1996,
	"./imagen9.jpg": 5295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;